module.exports = __webpack_public_path__ + "static/media/Alcester-Academy-Logo.58aa7027.png";